import React, { FC } from "react";
import { Editor } from "@tiptap/react";
import cn from "classnames";
import { Button } from "src/components/Button";
import { ButtonVariants } from "src/components/Button/types";
import { ITextAlignButton } from "./types";

interface Props extends ITextAlignButton {
  editor: Editor;
}

export const TextAlignButton: FC<Props> = ({
  editor,
  textAlign,
  icon: Icon,
}) => {
  const isActive = editor.isActive({ textAlign });

  const onClick = () => {
    if (isActive) editor.chain().focus().unsetTextAlign().run();
    else editor.chain().focus().setTextAlign(textAlign).run();
  };

  return (
    <Button
      type="button"
      className="!rounded-md !duration-100 !p-1"
      variant={isActive ? ButtonVariants.PRIMARY : ButtonVariants.SECONDARY}
      onClick={onClick}
    >
      <Icon
        title={`text-align:${textAlign}`}
        className={cn("w-5 h-5 transition-colors duration-100", {
          "text-black-base ": !isActive,
          "text-white-base": isActive,
        })}
      />
    </Button>
  );
};
